import { FlowLinksInput, FlowTriggersInput } from 'new/state/flowTriggers/types';
import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import * as actions from '../index';
import { isEmpty } from 'lodash';

export default function useFlowTriggersAdapter() {
  const dispatch = useDispatch<ThunkDispatch<any, any, Action>>();

  const createTriggers = useCallback(
    (sourceId: number, flowTriggers: FlowTriggersInput | FlowLinksInput) => {
      return dispatch(actions.createTriggers(sourceId, flowTriggers));
    },
    [],
  );

  const deleteTriggers = useCallback((sourceId: number, flowTriggers: number[]) => {
    return dispatch(actions.deleteTriggers(sourceId, flowTriggers));
  }, []);

  const createLinks = useCallback((flowNodeId: number, payload: any) => {
    if (isEmpty(payload)) {
      return;
    }
    return dispatch(actions.createLinks(flowNodeId, payload));
  }, []);

  const deleteLinks = useCallback((flowNodeId: number, payload: any) => {
    return dispatch(actions.deleteLinks(flowNodeId, payload));
  }, []);

  const deleteAllLinks = useCallback((flowNodeId: number) => {
    return dispatch(actions.deleteAllLinks(flowNodeId));
  }, []);

  return useMemo(() => {
    return {
      createTriggers,
      deleteTriggers,
      deleteAllLinks,
      createLinks,
      deleteLinks,
    };
  }, []);
}
